import Vue from "vue";
import Router from "vue-router";
import Dashboard from "./views/Dashboard/Dashboard.vue";
import Info from "./views/Dashboard/Info.vue";
import ActivatorApp from "./views/Dashboard/ActivatorApp.vue";
import RecoveryApp from "./views/Dashboard/RecoveryApp.vue";
import Devices from "./views/Dashboard/Devices.vue";
import Device from "./views/Dashboard/Device.vue";
import Documents from "./views/Dashboard/Document.vue";
import { ActionTypes } from "@/store/devices/actions";
import { ActionTypes as RecoveryAgentActionTypes } from "@/store/recovery-agent/actions";
import DataStreams from "@/views/Dashboard/DataStreams.vue";
import Wiki from "@/views/Dashboard/Wiki.vue";
import Onboarding from "@/views/Dashboard/Onboarding.vue";
import AuthService from "@/services/auth.service";
import Welcome from "@/views/Dashboard/Welcome.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      meta: { requiresAuth: true },
      component: Dashboard,
    },
    {
      path: "/datastreams",
      name: "datastreams",
      meta: { requiresAuth: true },
      component: DataStreams,
    },
    {
      path: "/devices",
      name: "devices",
      meta: { requiresAuth: true },
      component: Devices,
    },
    {
      path: "/devices/:id",
      name: "device info",
      meta: { requiresAuth: true },
      component: Device,
    },
    {
      path: "/clientInfo",
      name: "clientInfo",
      meta: { requiresAuth: true },
      component: Info,
    },
    {
      path: "/activatorApp",
      name: "activatorapp",
      meta: { requiresAuth: true },
      component: ActivatorApp,
    },
    {
      path: "/recoveryApp",
      name: "recoveryapp",
      meta: { requiresAuth: true },
      component: RecoveryApp,
    },
    {
      path: "/document",
      name: "document",
      meta: { requiresAuth: true },
      component: Documents,
    },
    {
      path: "/wiki",
      name: "wiki",
      meta: { requiresAuth: true },
      component: Wiki,
    },
    {
      path: "/onboarding",
      name: "onboarding",
      meta: { requiresAuth: false },
      component: Onboarding,
    },
    {
      path: "*",
      component: () => import("./views/not-found.vue"),
      meta: { title: "Not found" },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ? savedPosition : { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (!router.app.$store.getters.isLiveDataConnected) {
    await router.app.$store.dispatch(ActionTypes.ConnectLiveServer);
  }

  if (!router.app.$store.state.device.settings.apiClientId) {
    await router.app.$store.dispatch(ActionTypes.FetchSettings);
  }

  if (!router.app.$store.state.recoveryAgent.agents.length) {
    await router.app.$store.dispatch(RecoveryAgentActionTypes.FetchAgents);
  }

  if (!router.app.$store.state.device.devices.length) {
    await router.app.$store.dispatch(ActionTypes.FetchDevices);
  }

  return next();
});

export default router;
